import React, { FC } from 'react'

import { Avatar, Link, styled } from '@mui/material'

import { TradeAiAnalysisReferenceType } from './types'

interface TradeAiAnalysisReferenceProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  data: TradeAiAnalysisReferenceType
  children?: React.ReactNode
}

const StyledLink = styled(Link)({
  display: 'inline-flex',
  alignItems: 'center',
  textDecoration: 'none',
})

export const TradeAiAnalysisReference: FC<TradeAiAnalysisReferenceProps> = ({ data, ...props }) => {
  const { title, url } = data

  let domain = ''

  try {
    domain = new URL(url).hostname
  } catch {
    domain = url
  }

  const faviconUrl = domain ? `https://www.google.com/s2/favicons?domain=${domain}` : ''

  return (
    <StyledLink
      color="primary.main"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={typeof title === 'string' ? title : url}
      {...props}
    >
      {faviconUrl && <Avatar src={faviconUrl} alt={domain} sx={{ width: 16, height: 16, mr: 1 }} />}
      {title}
    </StyledLink>
  )
}

export default TradeAiAnalysisReference
